module.exports = __webpack_public_path__ + "img/btn_top.81bde8d7.svg";